<template>
  <div class="hearing-aid-sales__member-report page__container--no-padding">
    <Filters></Filters>
    <div id="sales-report__affix-anchor" class="sales-report-body">
      <ReportNavigation></ReportNavigation>
      <div class="fuel-utilization__no-data" v-if="filtersChanged || loaders.sections">
        <div v-if="filtersChanged">
          <h3>NOTICE:</h3>
          Please run a new report to apply the current filter settings.
        </div>
        <div v-else-if="loaders.sections && !globalLoading"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
      </div>

      <template v-if="!filtersChanged">
      <transition name="bounce">
        <div class="sales-report__section" v-if="displayTotals && !loaders.totals">
          <a class="sales-nav__anchor" id="a_Totals"></a>
          <div id="summary-title" class="sales-report-body__header-section">
            <div class="sales-report-body__section-title">Overall Summary</div>
          </div>
          <ReportTotals title="Report Totals" :entity-data="contents"></ReportTotals>
        </div>
      </transition>

      <transition name="fade">
        <div class="sales-report__section" v-if="displayVendors && !loaders.totalsByVendor">
          <a class="sales-nav__anchor" id="a_Vendors"></a>
          <div class="sales-report-body__header-section">
            <div class="sales-report-body__section-title">Vendor Summary</div>
          </div>
          <ReportVendors></ReportVendors>
        </div>
      </transition>

      <transition name="fade">
        <div class="sales-report__section" v-if="displayStats && !loaders.statsNational">
          <a class="sales-nav__anchor" id="a_Stats"></a>
          <div class="sales-report-body__header-section">
            <div class="sales-report-body__section-title">Statistics</div>
          </div>
          <ReportStats></ReportStats>
        </div>
      </transition>

      <div class="sales-report__section sales-report__section--location-summary" v-if="displayLocations && !loaders.locations">
        <a class="sales-nav__anchor" id="a_LocationSummary"></a>
        <div class="css-grid sales-report-body__header-section">
          <div class="sales-report-body__section-title">Location Summary</div>
        </div>
        <ReportLocationSummary></ReportLocationSummary>
      </div>

      <div class="sales-report__section" v-if="displayLocations && !loaders.locations">
        <a class="sales-nav__anchor" id="a_Locations"></a>
        <div class="css-grid sales-report-body__header-section">
          <div class="sales-report-body__section-title">Sales by Location</div>
        </div>
        <ReportTotals v-for="(location, index) in contents.locations" :key="`location-${index}`" :entity-data="location" :active-filters="{ location_ids: [location.location_id]}"></ReportTotals>
      </div>

      <div class="sales-report__section" v-if="displayPractices && !loaders.businesses">
        <a class="sales-nav__anchor" id="a_Practices"></a>
        <div class="css-grid sales-report-body__header-section">
          <div class="sales-report-body__section-title">Sales by Practice</div>
        </div>
        <ReportTotals v-for="(business, index) in contents.businesses" :key="`practice-${index}`" :entity-data="business" :active-filters="{ business_ids: [business.business_id]}"></ReportTotals>
      </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { Affix } from 'vue-affix';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import Filters from '../purchase-activity/Filters.vue';
  import ReportNavigation from '../purchase-activity/ReportNavigation.vue';
  import ReportTotals from '../purchase-activity/reports/ReportTotals.vue';
  import ReportVendors from '../purchase-activity/reports/ReportVendors.vue';
  import ReportStats from '../purchase-activity/reports/ReportStats.vue';
  import ReportLocationSummary from '../purchase-activity/reports/ReportLocationSummary.vue';

  export default {
    name: 'PurchaseActivityLayout',
    components: {
      ReportLocationSummary,
      Affix,
      MoonLoader,
      Filters,
      ReportNavigation,
      ReportTotals,
      ReportVendors,
      ReportStats,
    },
    computed: {
      ...mapGetters('purchaseActivity', [
        'initializers',
        'contents',
        'initialValues',
        'loaders',
        'filtersChanged',
        'globalLoading',
        'loadingSections',
        'displayedSections',
        'displayPractices',
        'displayLocations',
        'displayTotals',
        'displayVendors',
        'displayStats',
      ]),
    },
  };
</script>
